import { runInAction } from 'mobx';

import { logger } from '@cutwise/utils';

import store from '@/dmdrive/store';

export interface SnapshotMeta extends Record<string, unknown> {
  title?: string;
  preview?: Nullable<string>;
  state?: Record<string, unknown>;
  edited?: boolean;
}

interface SnapshotUser {
  id: number;
  username: string;
  email: string;
}

export class SnapshotModel {
  id!: string;
  meta!: SnapshotMeta;
  type!: string;
  user!: SnapshotUser;
  created!: string;
  updated!: string;
}

export class Snapshot extends SnapshotModel {
  constructor(model: SnapshotModel) {
    super();

    this.apply(model);
  }

  get title() {
    return this.meta?.title ?? '';
  }

  get preview() {
    return this.meta?.preview ?? '';
  }

  get isMy() {
    return this.user.id === store.appStore.user?.id;
  }

  get state() {
    try {
      if (!this.meta.state) {
        return {};
      }

      return this.meta.state;
    } catch (e) {
      logger.error('Unable to parse state', e);

      return {};
    }
  }

  get isNew() {
    return !this.meta.edited;
  }

  get username() {
    return this.user?.username || this.user?.email;
  }

  get author() {
    return `by ${this.isMy ? 'me' : this.username}`;
  }

  apply(model: SnapshotModel) {
    runInAction(() => {
      (Object.keys(model) as (keyof SnapshotModel)[]).forEach((key) => {
        switch (key) {
          default:
            this[key] = model[key] as never;

            break;
        }
      });
    });
  }
}
